var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',_vm._b({staticClass:"v-snackbar--material",model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},'v-snackbar',{
    ..._vm.$attrs,
    color: 'transparent',
  },false),[_c('base-material-alert',{staticClass:"ma-0",attrs:{"color":_vm.$attrs.color,"dismissible":_vm.dismissible,"type":_vm.type,"dark":""},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }